import FeatherIconsContainer from "../../Components/Icons/FeatherIcons/FeatherIcons"

const FeatherIcons = () => {
  return (
    <div className='page-body'>
      <FeatherIconsContainer />
    </div>
  )
}

export default FeatherIcons